import { render } from "./ConfigurationPanel.vue?vue&type=template&id=a2e41b60&scoped=true"
import script from "./ConfigurationPanel.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPanel.vue?vue&type=script&lang=ts"

import "./ConfigurationPanel.vue?vue&type=style&index=0&id=a2e41b60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a2e41b60"

export default script